import { urlBaseLeadCollector } from "../config";
import axiosInstance from "../../services/config/axiosinstance";

export default async function getConfigs() {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseLeadCollector}/adminPlusConfig/getConfigs`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    let _return = {
      data: [],
      count: 0,
    }

    for (let i = 0; i < _ret.data?.data?.length; i++) {
      _return.data.push({
        id: _ret.data?.data[i].id,
        code: _ret.data?.data[i].code,
      });
    }
    _return.count = _ret.data?.data?.length;

    return _return;
  } catch (error) {
    console.log('Error getConfigs', error);
    throw error;
  }
}
